import React, { useEffect } from "react";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";

import RegionsTableComponent from "../../../components/admin/regions-manager/RegionsTable";
import { RegionsAddDrawer } from "../../../components/admin/regions-manager/RegionsAddDrawer";

import { useGetRegionsListQuery } from "../../../store/masters/mastersApis";
import { defaultPaginate } from "../../../helpers/constants";
import { AddOutlined } from "@mui/icons-material";
import { SearchRecords } from "../../../components/Common/SearchRecords";

const RegionsContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination } = props;
    const { isLoading, data: regions, isFetching } = useGetRegionsListQuery(pagination);

    const handleAddRegion = () => {
        props.changeRegionsInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: null
        })
    }

    useEffect(() => {
        props.handlePaginationState(defaultPaginate);
    }, [])

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    }

    const handleDrawerClose = () => {
        props.changeRegionsInitialState({ showDrawer: false, formType: "", initialValues: null })
    }

    const handleRegionEdit = (data, type) => {
        let payload = {
            id: data.id,
            name: data.name,
            code: data.code,
            status: data.status
        };
        props.changeRegionsInitialState({ showDrawer: true, formType: type, initialValues: payload })
    }

    return (
        <Stack spacing={2}>
            <Grid container justifyContent="space-between">
                <Grid item xs={6} sx={{ alignSelf: "center" }}>
                    <Typography variant="h6" >Regions <span style={{ color: "gray", fontSize: "10px", verticalAlign: "super" }}>({regions?.count || 0})</span> </Typography>
                </Grid>
                <Grid item xs={6} sx={{ alignSelf: "center" }} display={"flex"} flexDirection={"row"} justifyContent={"flex-end"}>
                    <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                    <Button
                        disableElevation
                        variant="contained"
                        sx={{ borderRadius: "8px", marginLeft: 2, display: "flex", alignItems: "center", gap: 1, fontSize: "16px" }}
                        onClick={() => handleAddRegion()}
                    >
                        <AddOutlined />
                        New Region
                    </Button>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <RegionsTableComponent edit={(val, type) => handleRegionEdit(val, type)} loading={isLoading} fetching={isFetching} count={regions?.count} data={regions?.results || []} pagination={pagination} handlePagination={(val) => handlePagination(val)} />
                </Grid>
            </Grid>
            <RegionsAddDrawer show={showDrawer} close={handleDrawerClose} formType={formType} initialValues={initialValues} />
        </Stack >
    );
}

export default RegionsContainer;